import { Link } from "react-router-dom";
import { Reveal, Eyebrow, SectionTitle } from "./shared";
import { useSite } from "../../context/SiteContext";
import { imgUrl } from "../../lib/api";

export default function About() {
  const { content } = useSite();
  const about = content?.about;
  if (!about) return null;

  return (
    <section id="frei-lucas" className="py-20 lg:py-28 bg-warmwhite overflow-hidden" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 relative">
            <Reveal>
              <div className="relative">
                <div className="absolute -top-5 -left-5 w-full h-full border border-gold/40 rounded-2xl" />
                <img
                  src={imgUrl(about.image)}
                  alt="Dom Frei Lucas Macieira, celebrante de casamentos"
                  className="relative rounded-2xl w-full aspect-[4/5] object-cover gold-frame"
                  loading="lazy"
                  data-testid="about-image"
                />
                <div className="absolute -bottom-6 -right-4 sm:-right-6 bg-olive text-cream rounded-2xl px-6 py-5 shadow-xl max-w-[240px]">
                  <p className="font-script text-xl text-goldlight leading-snug" data-testid="about-quote">
                    “{about.cta_quote}”
                  </p>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pl-6">
            <Reveal>
              <Eyebrow>Sobre o celebrante</Eyebrow>
              <SectionTitle data-testid="about-title">{about.title}</SectionTitle>
            </Reveal>
            {about.paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.1 + i * 0.1}>
                <p className="mt-6 text-base sm:text-lg font-light text-cocoa leading-relaxed">{p}</p>
              </Reveal>
            ))}
            <Reveal delay={0.4}>
              <Link
                to="/dom-frei-lucas-macieira"
                data-testid="about-trajectory-button"
                className="mt-10 inline-flex items-center gap-3 border border-olive/30 text-olive hover:bg-olive hover:text-cream font-semibold text-sm tracking-wide px-7 py-4 rounded-full transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
              >
                CONHEÇA PADRE LUCAS MACIEIRA
                <span className="text-gold">→</span>
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
